/**
 * Login Page — Clerk Authentication
 *
 * Renders Clerk's <SignIn /> component for authentication.
 */

import { SignIn } from '@clerk/react';

export default function Login() {
  return (
    <main
      data-testid="page-login"
      className="flex min-h-screen items-center justify-center bg-muted/40 px-4 py-12"
    >
      <div className="flex w-full max-w-md flex-col items-center gap-8">
        <div className="space-y-2 text-center">
          <p className="text-sm font-medium text-primary">Edgeview Finance</p>
          <h1 className="text-2xl font-semibold tracking-tight">Commercial Finance CRM</h1>
          <p className="text-sm text-muted-foreground">
            Sign in with your staff account to continue.
          </p>
        </div>

        <SignIn
          fallbackRedirectUrl="/"
          appearance={{
            elements: {
              rootBox: 'w-full',
              card: 'w-full shadow-sm',
            },
          }}
        />
      </div>
    </main>
  );
}
